<template>
  <a-modal
    centered
    :maskClosable="false"
    title="挂账客户"
    v-model="visible"
    width="800px"
    @ok="onSubmit"
    @cancel="onCancel"
  >
    <data-table ref="dataTable" :option="option"> </data-table>
  </a-modal>
</template>

<script>
import { DataTable } from "@/components/dataTable";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      option: {},
      visible: false,
      info: {}
    };
  },
  created() {
    this.option = {
      headSearch: {
        colnum: 1,
        content: [
          {
            label: "名称",
            name: "Name"
          }
        ]
      },
      grid: {
        api: "Customer_OfferCreditCustomerList",
        props: {
          scroll: {
            x: false,
            y: "calc(100vh - 500px)"
          }
        },
        columns: [
          {
            title: "序号",
            width: "8%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "名称",
            dataIndex: "Name",
            width: "20%"
          },
          {
            title: "简称",
            dataIndex: "ShortName",
            width: "10%"
          },
          {
            title: "单次限额",
            dataIndex: "SingleTimeLimit",
            width: "15%",
            align: "right"
          },
          {
            title: "总限额",
            dataIndex: "TotalLimit",
            width: "20%",
            align: "right"
          },
          {
            title: "余额",
            dataIndex: "Balance",
            align: "right"
          }
        ]
      }
    };
  },
  methods: {
    show(record) {
      this.visible = true;
      this.info = record;
    },
    onCancel() {
      this.visible = false;
      this.$emit("cancel", this.info);
    },
    onSubmit() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请选择挂账客户！");
        return false;
      }
      this.$emit("submit", this.info, row);
      this.visible = false;
    }
  }
};
</script>

<style></style>
